export const testimonials = [
    {
        id: 1,
        text: '"When I first came to Dr. Pecsok, I didn\'t believe in chiropractic care. However, after meeting him, I realized that he was a very knowledgeable and caring doctor. He has helped me with my back pain and I am now a believer in chiropractic care."',
    },
    {
        id: 2,
        text: '"Dr. Chris has helped me release emotional pain of which I was not aware existed. It has increased my stamina and energy level, so that I can now exercise five times per week. Both physically and emotionally, I feel more peaceful."',
    },
    {
        id: 3,
        text: '"Thanks for making a difference in my life Dr. Chris!"'
    },
    {
        id: 4,
        text: '"Dr Chris\'s care has brought a lot of awareness and improvement to my health. "',
    },
    {
        id: 5,
        text: '"The network chiropractic work has been a wonderful experience for my family and I. I feel 100% more in tune with the present moment. Endless energy, and incredibly at peace with the process of life. I would highly recommend it to anyone!"',
    },
    {
        id: 6,
        text: '"I am completely relieved of my allergies and asthma, ever since the second visit. Now I can breathe free and clear. "',
    },
    {
        id: 7,
        text: '"I feel better overall - healthier, more energy, less depressed and I\'m taking less herbs!"',
    },
    {
        id: 8,
        text: '"My pain has decreased dramatically, my mobility has increased and I am able to move with much more ease. I am so grateful for Dr. Pecsok for helping me, I can\'t imagine what condition I\'d be in if I started not seeing Dr. Pecsok. Thanks!"',
    },
    {
        id: 9,
        text: '"Chiropractic "worked" for me in the sense that my troubling symptoms went away and my general health improved steadily over time. I now walk briskly and without an aid of a cane. My posture has improved. Not only can I pick up and carry my children - they can take a flying leap into my arms! [...] I have more energy and a more positive outlook. I am optimistic about my future."',
    },
    {
        id: 10,
        text: '"Thank you for being there when I needed you. The treatments greatly helped the healing process. You were a "godsend" when I needed you."',
    },
    {
        id: 11,
        text: '"With Chris, I have been able to feel safe and go through the experience feeling supported and loved. "',
    },
    {
        id: 12,
        text: '"I thank you for creating an environment that is so safe and nurturing for healing, joy, laughter, tears and spirituality. "',
    },
    {
        id: 13,
        text: '"Thanks to Dr. Pecsok, I have no worries getting up, using my arms, and walking up and down the stairs. [...] I can\'t thank Dr. Pecsok enough for giving my life back to me."',
    },
    {
        id: 14,
        text: '"My attitude is better. I have regained my sense of humor. My lower back pain is minimal, almost gone! My anxiety levels have gone down. If anyone told me this would be remedied so easily, I wouldn\'t have believed them. "',
    },
    {
        id: 15,
        text: '"Elimination of low back pain. Open, easy breathing. Greater joy and peace." ',
    },
    {
        id: 16,
        text: '"If you want to be fine, do this regularly. Get your spine alligned by Dr. Chris!" ',
    },
];
